import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-ai-gateway-brand))",
      d: "M6.013 10.5a.48.48 0 0 1-.357-.144.48.48 0 0 1-.143-.356v-.575a2.6 2.6 0 0 1-.988-.437 2.2 2.2 0 0 1-.688-.875.42.42 0 0 1-.006-.37.51.51 0 0 1 .294-.28.44.44 0 0 1 .362.006.58.58 0 0 1 .288.268q.212.375.537.57.326.193.8.193.513 0 .87-.231.356-.231.356-.719 0-.438-.276-.694-.274-.255-1.275-.581-1.074-.338-1.475-.806-.4-.47-.4-1.144 0-.813.525-1.263t1.076-.512V2q0-.213.143-.356a.48.48 0 0 1 .357-.144q.212 0 .356.144A.48.48 0 0 1 6.513 2v.55q.474.075.825.306.35.231.574.569.113.163.044.363a.47.47 0 0 1-.281.287.47.47 0 0 1-.362.006.9.9 0 0 1-.35-.244 1.1 1.1 0 0 0-.382-.268 1.4 1.4 0 0 0-.544-.094q-.549 0-.837.244a.76.76 0 0 0-.288.606q0 .413.375.65.376.237 1.3.5.862.25 1.307.794.444.543.444 1.256 0 .888-.525 1.35t-1.3.575V10q0 .212-.144.356a.48.48 0 0 1-.356.144"
    }, null, -1)
  ]))]))
}
export default { render: render }